const topShopSearchBox = document.getElementById("topShopSearchBox");
const topShopSearchBtn = document.getElementById("topShopSearchBtn");

topShopSearchBtn.addEventListener("click", () => {
  const searchBoxValue = topShopSearchBox.value;
  if (searchBoxValue != "") {
    window.location.href = `./pages/shoplist-detail?keyword=${searchBoxValue}`;
  } else {
    window.location.href = "./pages/shoplist";
  }
});

window.document.onkeydown = function (event) {
  if (event.key === "Enter") {
    const searchBoxValue = topShopSearchBox.value;
    if (searchBoxValue != "") {
      window.location.href = `./pages/shoplist-detail?keyword=${searchBoxValue}`;
    } else {
      window.location.href = "./pages/shoplist";
    }
  }
};
